import { SvgIconProps } from '@mui/material'
import React from 'react'

const Pending: React.FC<SvgIconProps> = (props) => {
  return (
    <svg
      width={96}
      height={96}
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx={48} cy={48} r={48} fill='#FFF9DA' />
      <path
        d='M59.3698 61.2266H57.8174V58.9663H56.9418C56.9407 58.9663 56.9393 58.9667 56.9382 58.9667C56.7747 58.9667 56.6097 58.9211 56.4623 58.8261L48.8733 53.9298C48.2562 53.5316 47.4586 53.5321 46.8417 53.9308L39.2687 58.8257C39.1211 58.9213 38.9554 58.9662 38.7915 58.966V58.9663H37.8959V61.2266H36.3438C35.8583 61.2266 35.4648 61.6201 35.4648 62.1055C35.4648 62.5909 35.8583 62.9844 36.3438 62.9844H59.37C59.8552 62.9844 60.2489 62.5909 60.2489 62.1055C60.2489 61.6201 59.8552 61.2266 59.3698 61.2266Z'
        fill='#D0AF00'
      />
      <path
        d='M36.3438 34.7422H37.8959V37.3134C37.8959 41.1007 39.8881 44.5656 43.5054 47.0699C43.6218 47.1509 43.8068 47.4702 43.8068 47.9844C43.8068 48.4985 43.6216 48.8182 43.505 48.899C40.3541 51.0805 38.437 53.9911 37.995 57.2085H38.5324L45.8876 52.4543C47.0836 51.6815 48.6298 51.6809 49.8264 52.4529L57.1976 57.2085H57.7184C57.2764 53.9911 55.3593 51.0805 52.2084 48.899C52.0917 48.8182 51.9066 48.4985 51.9066 47.9846C51.9066 47.4706 52.0917 47.1509 52.2086 47.0699C55.8256 44.5656 57.8174 41.1007 57.8178 37.3137V34.7422H59.3698C59.8552 34.7422 60.2487 34.3487 60.2487 33.8633C60.2487 33.3779 59.8552 32.9844 59.3698 32.9844H36.3438C35.8583 32.9844 35.4648 33.3779 35.4648 33.8633C35.4648 34.3487 35.8583 34.7422 36.3438 34.7422Z'
        fill='#D0AF00'
      />
    </svg>
  )
}

export default Pending
